import type { OfertasPrimariasFilter } from 'common/genericTypes';
import type { GridColDef } from '@mui/x-data-grid-pro';

/** Item mínimo do filtro emitido pelo DataGrid. */
export interface ItemFiltroOfertaPrimaria {
  columnField: string;
  operatorValue?: string;
  value?: unknown;
}

/**
 * Habilita o filtro por nome do investidor somente na grade de ofertas primárias.
 */
export const configurarColunasRelatorioOfertasPrimarias = (
  colunas: Array<GridColDef>,
  operadores: GridColDef['filterOperators']
): Array<GridColDef> =>
  colunas.map((coluna) =>
    coluna.field === 'NOME_INVESTIDOR'
      ? {
          ...coluna,
          filterOperators: operadores,
          filterable: true,
        }
      : coluna
  );

/**
 * Converte os itens do DataGrid para o contrato de filtros de ofertas primárias.
 */
export const montarFiltrosOfertasPrimarias = (
  itens: Array<ItemFiltroOfertaPrimaria>
): Array<OfertasPrimariasFilter> => {
  const filtros = new Array<OfertasPrimariasFilter>();

  itens.forEach((item) => {
    const operador =
      item.operatorValue === 'startsWith'
        ? 'STARTS_WITH'
        : item.operatorValue === 'endsWith'
        ? 'ENDS_WITH'
        : item.operatorValue?.toUpperCase();

    let valorFormatado = item.value?.toString();
    if (valorFormatado) {
      if (item.columnField === 'tipo') {
        valorFormatado = valorFormatado.replace('_', ' ');
      }
      if (item.columnField === 'CRIADO_EM' || item.columnField === 'DATA_LIQUIDACAO') {
        const partes = valorFormatado.split('-');
        valorFormatado = `${partes[2]}/${partes[1]}/${partes[0]}`;
      }

      filtros.push({
        columnType: item.columnField.toUpperCase(),
        operationFilterType: operador,
        value: valorFormatado,
      });
    } else if (operador === 'ISNOTEMPTY' || operador === 'ISEMPTY') {
      filtros.push({
        columnType: item.columnField.toUpperCase(),
        operationFilterType: operador,
        value: '',
      });
    }
  });

  return filtros;
};
